import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { NotificationService } from './notification.service';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

/** Type of the handleError function returned by HttpErrorHandler.createHandleError */
export type HandleError = <T>(operation?: string, result?: T) => (error: HttpErrorResponse) => Observable<T>;

/** Handles HttpClient errors */
@Injectable()
export class HttpErrorHandler {
  constructor(
    private _notificationService: NotificationService,
    private _globalService: GlobalService,
    private _router: Router,
    private _oauthService: OAuthService
  ) {}

  /** Create curried handleError function that already knows the service name */
  createHandleError =
    (serviceName = '') =>
    <T>(operation = 'operation', result = {} as T) =>
      this.handleError(serviceName, operation, result);

  /**
   * Returns a function that handles Http operation failures.
   * This error handler lets the app continue to run as if no error occurred.
   * @param serviceName = name of the data service that attempted the operation
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  handleError<T>(serviceName = '', operation = 'operation', result = {} as T) {
    return (error: HttpErrorResponse): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      const message =
        error.error instanceof ErrorEvent
          ? error.error.message
          : `server returned code ${error.status} - ${error.statusText} with error "${error.error.detail}" with body "${error}"`;

      switch (error.status) {
        default:
          this._notificationService.showError(message, 'Err');
          break;
        case 403:
          let availableRoutes = this._globalService.availableRoutes;

          if (availableRoutes) {
            this._router.navigate([availableRoutes[0]]);
          } else {
            this._router.navigate(['']);
          }
          break;
        case 401:
          this._oauthService.logOut();
          break;
      }

      // Let the app keep running by returning a safe result.
      return of(result);
    };
  }
}

/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/
